module.exports = __webpack_public_path__ + "img/86.a67b1044.jpg";